import AffiliateHubLogger from '../../../util/affiliate-hub-logger';
import { PzStore } from 'stores';

const assignCampaign = async (
  pzStore: PzStore,
  logger: AffiliateHubLogger,
  programName: string,
  partnerId: string,
  campaignTermsId: string,
  accessToken: string,
) => {
  try {
    const response = await pzStore.assignCampaign(programName, partnerId, campaignTermsId, accessToken);

    if (response.success) {
      const camref = response.body.camref;

      return camref;
    } else {
      throw response.error;
    }
  } catch (e) {
    throw e;
  }
};

export default assignCampaign;
